import useCurrentUser from "./useCurrentUser";
import { EASASPermissionKey } from "../models/enum/permissions";
import "utils/file-utils";
import { UserDTO } from "../api/model/user/UserDTO";
import { useUserState } from "../store/user-store";

export function useHasPermissions(requiredPerms: EASASPermissionKey | EASASPermissionKey[]) {
  const { currentUser } = useCurrentUser();

  return checkPermission(requiredPerms, currentUser);
}

export function checkPermission(
  requiredPerms: EASASPermissionKey | EASASPermissionKey[],
  currentUser?: UserDTO
) {
  if (!currentUser) currentUser = useUserState.getState().currentUser;

  // No permissions are required - allow
  if (!requiredPerms || requiredPerms.length === 0) {
    return true;
  }

  // No user is logged in - disallow
  if (!currentUser) {
    return false;
  }

  // If no user permissions are found - disallow
  const { effectivePermissions } = currentUser;
  if (!effectivePermissions || effectivePermissions.length === 0) {
    return false;
  }

  // If a single permission is passed, convert it to an array
  let checkedPermissions = requiredPerms;
  if (checkedPermissions && !Array.isArray(checkedPermissions)) checkedPermissions = [checkedPermissions];

  // If any of the permissions are not found - disallow
  for (const permission of checkedPermissions) {
    // Check if permission is included but ignore case, and convert . : - to _
    if (!effectivePermissions.some(p => convertPermission(p) === convertPermission(permission))) {
      return false;
    }
  }

  // All permissions were found - allow
  return true;
}

function convertPermission(perm: string) {
  return perm.toUpperCase().replace(/[.:-]/g, "_");
}
